var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-account-detail"},[_c('el-row',[_c('el-col',[(_vm.bussinessAccountId === '0')?_c('h2',[_vm._v(" Yahoo!JAPAN ビジネスID 新規登録 ")]):_c('h2',[_vm._v("Yahoo!JAPAN ビジネスID 編集")])])],1),_c('BussinessAccountEditor',{attrs:{"bussinessAccountId":_vm.bussinessAccountId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }